import { toast } from "react-toastify";
import api from "../../../Helper/api";
import { Slice, callTypes } from "./leaveSlice";

const { actions } = Slice;

export const createLeave = (data) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  try {
    const response = await api.post("/leave", data);

    dispatch(actions.createAsk(response.data));

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Bilinmeyen hata";

    dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));

    // ❗ Form.jsx toast'ında gösterebilmek için hata mesajını da döndür
    return {
      status: error?.response?.status || 500,
      data: { message: errMsg },
    };
  }
};

export const getLeave = (auth) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  const endpoint =
    auth?.userType === "admin" ? "/leave" : "/leave/my";

  try {
    const response = await api.get(endpoint);
    dispatch(actions.gets(response.data.leaves));
    return response.data;
  } catch (error) {
    const err =
      error?.response?.data?.message ||
      error?.message ||
      "Bilinmeyen hata";
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return false;
  }
};

export const getLeaveRej = () => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    const response = await api.get("/leave");
    dispatch(actions.gets(response.data.leaves));
    return response.data;
  } catch (error) {
    const err =
      error?.response?.data?.message ||
      error?.message ||
      "Bilinmeyen hata";
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return false;
  }
};

export const createLeaveByAdmin = (data) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    const response = await api.post("/leave/admin-create", data);
    dispatch(actions.createAsk(response.data));
    return { status: response.status, data: response.data };
  } catch (error) {
    const errMsg = error?.response?.data?.message || error?.message || "Bilinmeyen hata";
    dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));
    return { status: error?.response?.status || 500, data: { message: errMsg } };
  }
};

export const addLeave = (data) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  if (data) {
    dispatch(actions.add(data));
    return data;
  }
};

export const deleteLeave = (data) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    const id = data._id || data.id;
    const response = await api.delete(`/leave/${id}`);
    if (response?.data?.leave) {
      dispatch(actions.remove(response.data.leave));
    }
    return response.data.state;
  } catch (error) {
    const err =
      error?.response?.data?.message ||
      error?.message ||
      "Bilinmeyen hata";
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return false;
  }
};

export const systemLeaveAction = (data) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    await api.post(`/leave/system/${data.tc}`, data);
    return true;
  } catch (error) {
    const err =
      error?.response?.data?.message ||
      error?.message ||
      "Bilinmeyen hata";
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return false;
  }
};

export const downloadAttachment = (id) => async (dispatch) => {
  try {
    const response = await api.get(`/leave/file/${id}`, { responseType: "blob" });
    return response;
  } catch (error) {
    const err = error?.response?.data?.message || error?.message || "Dosya indirilemedi";
    toast.error(err);
    return null;
  }
};

// silent: toplu silme sırasında her dosya için ayrı toast göstermemek için kullanılır
export const deleteAttachment = (id, { silent = false } = {}) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    const response = await api.delete(`/leave/attachment/${id}`);
    if (!silent) toast.success("Dosya silindi");
    return response.data.state ?? true;
  } catch (error) {
    const err = error?.response?.data?.message || error?.message || "Dosya silinemedi";
    if (!silent) toast.error(err);
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return false;
  }
};
// Tüm sistem izni işlemlerini siler; kullanıcı bakiyelerinin geri alınması sunucuda atomik yapılır
export const deleteSystemLeaveTransactions = () => async (dispatch) => {
  try {
    const response = await api.delete("/leave/transactions/system");
    return { deletedCount: response.data.deletedCount ?? 0 };
  } catch (error) {
    const err = error?.response?.data?.message || error?.message || "Bilinmeyen hata";
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return null;
  }
};
export const getLeaveTransactions = (tc) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  try {
    const response = await api.get(`/leave/transactions/${tc}`);

    if (!response.data.transactions || response.data.transactions.length === 0) {
      dispatch(actions.transactions([]));
      return { transactions: [] };
    }

    const transactions = response.data.transactions.map((t) => {
      if (t.actionBy && typeof t.actionBy === "object") {
        return {
          ...t,
          actionByDisplay: `${t.actionBy.name || ""} ${t.actionBy.surname || ""} (${t.actionBy.userType || "?"})`,
        };
      } else if (typeof t.actionBy === "string") {
        return { ...t, actionByDisplay: t.actionBy };
      } else {
        return { ...t, actionByDisplay: "Bilinmiyor" };
      }
    });

    dispatch(actions.transactions(transactions));
    return { ...response.data, transactions };
  } catch (error) {
    dispatch(actions.transactions([]));
    const err =
      error?.response?.data?.message ||
      error?.message ||
      "Bilinmeyen hata";
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return false;
  }
};

export const approve = (data) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    await api.patch(`/leave/approve/${data._id}`);
    return true;
  } catch (error) {
    const err =
      error?.response?.data?.message ||
      error?.message ||
      "Bilinmeyen hata";
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return false;
  }
};

export const reject = ({ id, reason }) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    await api.patch(`/leave/reject/${id}`, { rejectReason: reason });
    return true;
  } catch (error) {
    const err =
      error?.response?.data?.message ||
      error?.message ||
      "Bilinmeyen hata";
    dispatch(actions.catchError({ err, callType: callTypes.list }));
    return false;
  }
};
